module.exports = __webpack_public_path__ + "img/4_6d52d2f4d.png";